export default __webpack_public_path__ + "static/media/football.c82c0314.webp";